import Swiper from 'swiper';
import { Navigation, Thumbs, EffectFade, Autoplay } from "swiper/modules";

import gsap from "gsap";
import InertiaPlugin from "gsap/InertiaPlugin";
import Draggable from "gsap/Draggable";
import { loadImagesPromise } from './funcs';

gsap.registerPlugin(InertiaPlugin, Draggable)

const slidesOnUpdate = (swiper) => {

    // 実際のスライド数を正しく計算
    let realSlidesLength;
    if (swiper.params.loop) {
        // loopの場合：元のスライド数から複製分を引く
        realSlidesLength = swiper.slides.length;
        if (swiper.loopedSlides) {
            realSlidesLength -= swiper.loopedSlides * 2;
        }
    } else {
        // loopなしの場合：そのまま
        realSlidesLength = swiper.slides.length;
    }

    // 念のため、slides配列から直接カウント（data-swiper-slide-indexがあるもの）
    const originalSlides = Array.from(swiper.slides).filter(slide =>
        slide.getAttribute('data-swiper-slide-index') !== null
    );

    if (originalSlides.length > 0) {
        realSlidesLength = originalSlides.length;
    }

    const currentSlide = swiper.realIndex;

    // 前後のスライド計算
    const previousSlide = currentSlide === 0
        ? realSlidesLength - 1
        : currentSlide - 1;

    const nextSlide = currentSlide === realSlidesLength - 1
        ? 0
        : currentSlide + 1;

    const res = {
        current: currentSlide,
        previous: previousSlide,
        next: nextSlide,
        total: realSlidesLength
    }

    return res;
}

let pcFv: Swiper, spFv: Swiper

const pcFvInit = () => {
    // p4fps.innerHTML = JSON.stringify(["pcFvInit", new Date(), pcFv])
    if (!pcFv) {
        try {
            spFv.destroy()
            spFv = null
        } catch (error) {

        }

        loadImagesPromise('.fvSwiper.attr-pc img')
            .then(images => {
                pcFv = new Swiper(".fvSwiper.attr-pc", {
                    modules: [Autoplay, EffectFade],
                    // loop: true,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true,
                    },
                    speed: 10,
                    autoplay: {
                        delay: 500,
                        disableOnInteraction: true,
                        waitForTransition: false,
                    },
                    allowTouchMove: false,
                    on: {
                        init: function () {
                            let observer = null;

                            this.autoplay.stop();

                            observer = new IntersectionObserver((entries) => {
                                entries.forEach(entry => {
                                    if (entry.isIntersecting) {
                                        this.autoplay.start();
                                    } else {
                                        this.autoplay.stop();
                                    }
                                });
                            }, { threshold: 0.1 });

                            observer.observe(this.el);

                            // observerをインスタンスに保存してdestroy時に使える様にする
                            this._viewportObserver = observer;
                        },
                        destroy: function () {
                            if (this._viewportObserver) {
                                this._viewportObserver.disconnect();
                                this._viewportObserver = null;
                            }
                        }
                    }
                });
            })
            .catch(error => {
                console.error('画像読み込みエラー:', error);
            });
    }
}

const spFvInit = () => {
    if (!spFv) {
        try {
            pcFv.destroy()
            pcFv = null
        } catch (error) {

        }

        try {

            loadImagesPromise('.fvSwiper.attr-sp img')
                .then(images => {
                    spFv = new Swiper(".fvSwiper.attr-sp", {
                        modules: [Autoplay, EffectFade],
                        // loop: true,
                        effect: "fade",
                        fadeEffect: {
                            crossFade: true,
                        },
                        speed: 10,
                        autoplay: {
                            delay: 500,
                            disableOnInteraction: true,
                            waitForTransition: false,
                        },
                        allowTouchMove: false,
                        on: {
                            init: function () {
                                let observer = null;

                                this.autoplay.stop();

                                observer = new IntersectionObserver((entries) => {
                                    entries.forEach(entry => {
                                        if (entry.isIntersecting) {
                                            this.autoplay.start();
                                        } else {
                                            this.autoplay.stop();
                                        }
                                    });
                                }, { threshold: 0.1 });

                                observer.observe(this.el);

                                // observerをインスタンスに保存してdestroy時に使える様にする
                                this._viewportObserver = observer;
                            },
                            destroy: function () {
                                if (this._viewportObserver) {
                                    this._viewportObserver.disconnect();
                                    this._viewportObserver = null;
                                }
                            }
                        }
                    });
                })
                .catch(error => {
                    console.error('画像読み込みエラー:', error);
                });

        } catch (error) {

        }
    }
}

const fvOnResize = () => {
    if (innerWidth > 767) {
        pcFvInit()
    } else {
        spFvInit()
    }
}

fvOnResize()
let resizeTimeout;

window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
        fvOnResize()
    }, 400);
});


new Swiper(".newsSwiper", {
    modules: [Navigation],
    navigation: {
        nextEl: document.querySelector(".news__innerBlock .swiper-button-next") as HTMLElement,
        prevEl: document.querySelector(".news__innerBlock .swiper-button-prev") as HTMLElement,
    },
});

new Swiper(".campSwiper", {
    slidesPerView: "auto",
});

const pros = document.querySelectorAll(`.Product`)

pros.forEach((pro) => {

    const mainElm = pro.querySelector(".lineupSwiper") as HTMLElement
    const thumbElm = pro.querySelector(".lineupThumbSwiper") as HTMLElement
    const infoRows = pro.querySelectorAll(".Product__infoUpperInfoRow") as NodeListOf<HTMLElement>
    let lineupThumbSwiper: Swiper, lineupSwiper: Swiper

    const onSlideChange = (swiper: Swiper) => {
        if (infoRows.length > 0) {
            const res = slidesOnUpdate(swiper);
            infoRows.forEach((infoRow) => {
                infoRow.classList.remove("is-crnt")
            })
            infoRows[res.current].classList.add("is-crnt")
        }
    }

    lineupThumbSwiper = new Swiper(thumbElm, {
        modules: [Navigation],
        navigation: {
            nextEl: pro.querySelector(".swiper-button-next") as HTMLElement,
            prevEl: pro.querySelector(".swiper-button-prev") as HTMLElement,
        },
        slidesPerView: "auto",
        on: {
            init: (swiper) => {
                if (innerWidth > 767) {
                    // swiper.slideToLoop(1);
                } else {
                }
            },
            slideChange: (swiper) => {
                const res = slidesOnUpdate(swiper);
                // console.log(res);
                try {
                    if (innerWidth > 767) {
                        // lineupSwiper.slideToLoop(res.previous)
                        lineupSwiper.slideToLoop(res.current)
                    } else {
                        lineupSwiper.slideToLoop(res.current)
                    }
                } catch (error) {
                }
            },
            click: (swiper) => {
                if (swiper.clickedSlide) {
                    // クリックされたスライドのインデックスを取得
                    const clickedIndex = swiper.clickedSlide.getAttribute("data-swiper-slide-index");
                    // console.log(clickedIndex);
                    if (clickedIndex !== undefined) {
                        let index = parseInt(clickedIndex) + (innerWidth > 767 ? 0 : 0)
                        if (index > swiper.slides.length - 1) {
                            index = index - swiper.slides.length
                        }
                        swiper.slideToLoop(index);

                        if (innerWidth > 767) {
                        } else {
                            lineupSwiper.slideToLoop(index)
                        }
                    }
                }
            },
        },
        // centeredSlides: true,
        loop: !pro.classList.contains("attr-small-flavor"),
        breakpoints: {
            768: {
                centeredSlides: false,
                loop: true,
            }
        },
    });

    lineupSwiper = new Swiper(mainElm, {
        modules: [Navigation, Thumbs, EffectFade],
        slidesPerView: "auto",
        loop: true,
        allowTouchMove: false,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        on: {
            afterInit: (swiper) => {
                onSlideChange(swiper)
            },
            slideChange: (swiper) => {
                onSlideChange(swiper)

                swiper.el.closest(`.Product`).classList.add(`is-changing`)
                setTimeout(() => {
                    swiper.el.closest(`.Product`).classList.remove(`is-changing`)
                }, 400);

                try {
                    const res = slidesOnUpdate(swiper);

                    const sldElms = lineupThumbSwiper.el.querySelectorAll(`.swiper-slide`)
                    const targetSldElm = lineupThumbSwiper.el.querySelector(`.swiper-slide[data-swiper-slide-index="${res.current}"]`)

                    sldElms.forEach((sldElm) => {
                        sldElm.classList.remove(`swiper-slide-thumb-active`)
                    })

                    targetSldElm.classList.add(`swiper-slide-thumb-active`)

                } catch (error) {
                    // console.log(error);
                }
            },
        },
        // thumbs: {
        //     swiper: lineupThumbSwiper,
        //     autoScrollOffset: 1,
        // }
    });
})

{
    let resizeTimeout;
    let flavorSwiper: Swiper = null
    let circleDraggable: globalThis.Draggable[] = null
    let isCircleBeingDragged = false
    let CircleBeingDraggedReqId = null

    const flavorSwiperElm = document.querySelector(`.flavorSwiper`) as HTMLElement

    const imgs = flavorSwiperElm.parentNode.querySelectorAll(`.flavor__innerPcCntCtrlImgsImg`)
    const crntCircle = flavorSwiperElm.parentNode.querySelector(`.flavor__innerPcCntCtrlBarCrnt`)
    let crntCirclePoints = []

    const draggableInitOrResise = (swiper: Swiper) => {

        if (circleDraggable && circleDraggable[0]) {
            circleDraggable[0].kill();
            crntCirclePoints = []
        }

        //足跡のドラッグ
        const bar = swiper.el.parentNode.querySelector(`.flavor__innerPcCntCtrlBar`)
        const barRect = bar.getBoundingClientRect()
        const crntCircleRect = crntCircle.getBoundingClientRect()

        imgs.forEach((img, imgIndex) => {
            const imgRect = img.getBoundingClientRect()
            const imgCenter = (imgRect.top - barRect.top) + (imgRect.height / 2)
            crntCirclePoints.push(imgCenter - crntCircleRect.height / 2)
        })

        // console.log(crntCirclePoints);

        const onDragOrMoving = (d) => {
            const crntCircleRect = crntCircle.getBoundingClientRect()
            const barRect = bar.getBoundingClientRect()
            const trueY = crntCircleRect.top - barRect.top
            // console.log(trueY);
            // 現在位置が最も近いスナップポイントを取得
            const closestIndex = crntCirclePoints.reduce((bestIndex, point, index) => {
                const currentDistance = Math.abs(crntCirclePoints[bestIndex] - trueY);
                const newDistance = Math.abs(point - trueY);
                return newDistance < currentDistance ? index : bestIndex;
            }, 0);

            if (flavorSwiper) {
                flavorSwiper.slideTo(closestIndex)
            }

            CircleBeingDraggedReqId = requestAnimationFrame(() => {
                onDragOrMoving(d)
            })
        }

        gsap.set(crntCircle, { y: crntCirclePoints[swiper.realIndex] })
        circleDraggable = Draggable.create(crntCircle, {
            type: "y",
            liveSnap: {
                y: crntCirclePoints,
            },
            onDragStart: (d) => {
                isCircleBeingDragged = true
                onDragOrMoving(d)
            },
            onDragEnd: () => {
                isCircleBeingDragged = false
                setTimeout(() => {
                    cancelAnimationFrame(CircleBeingDraggedReqId);
                    CircleBeingDraggedReqId = null;
                }, 400);
            },
        });
    }

    const flavorOnInit = (swiper: Swiper) => {
        imgs.forEach((img, imgIndex) => {
            img.addEventListener("click", () => {
                swiper.slideTo(imgIndex)
            })
        });

        draggableInitOrResise(swiper)
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                swiper.updateSlides()
                swiper.updateSize()
                swiper.updateAutoHeight()
                swiper.slideReset()
                draggableInitOrResise(swiper)
            }, 1000);
        })
    }

    const flavorOnUpdate = (swiper: Swiper) => {
        const res = slidesOnUpdate(swiper)

        imgs.forEach((img, imgIndex) => {
            img.classList.remove(`is-crnt`)

            if (imgIndex === res.current) {
                img.classList.add(`is-crnt`)
            }
        })
        if (!isCircleBeingDragged) {
            gsap.set(crntCircle, { y: crntCirclePoints[swiper.realIndex] })
        }
    }

    window.addEventListener("load", () => {
        flavorSwiper = new Swiper(flavorSwiperElm, {
            modules: [Navigation, EffectFade],
            navigation: {
                nextEl: ".flavor__innerPcCntCtrlNav .swiper-button-next",
                prevEl: ".flavor__innerPcCntCtrlNav .swiper-button-prev",
            },
            speed: 0,
            direction: "vertical",
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            on: {
                init: (swiper) => {
                    flavorOnInit(swiper)
                    flavorOnUpdate(swiper)
                },
                slideChange: flavorOnUpdate,
            }
        });
        window.flavorSwiper = flavorSwiper
    })
}

{
    const goodSlds = document.querySelectorAll(`.goods__innerSldsSld`)

    goodSlds.forEach((goodSld) => {

        const thumbElm = goodSld.querySelector(`.goodsThumbSwiper`);

        const thumbSwiper = new Swiper(thumbElm, {
            modules: [Thumbs],
            slidesPerView: "auto",
            centeredSlides: thumbElm.classList.contains(`attr-centered`),
            // loop: true,
            loopAdditionalSlides: 10,
            on: {
                click: (swiper) => {
                    try {
                        // クリックされたスライドのインデックスを取得
                        const clickedIndex = swiper.clickedSlide.getAttribute("data-swiper-slide-index");
                        // console.log(clickedIndex);
                        if (clickedIndex !== undefined) {
                            let index = parseInt(clickedIndex)
                            if (index > swiper.slides.length - 1) {
                                index = index - swiper.slides.length
                            }

                            swiper.slideToLoop(index);
                        }
                    } catch (error) {
                        console.warn(error);
                    }
                }
            },
        });

        const mainSwiper = new Swiper(goodSld.querySelector(`.goodsMainSwiper`), {
            modules: [Navigation, Thumbs, EffectFade],
            navigation: {
                nextEl: goodSld.querySelector(".swiper-button-next"),
                prevEl: goodSld.querySelector(".swiper-button-prev"),
            },
            thumbs: {
                swiper: thumbSwiper,
            },
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            on: {
                afterInit: (swiper) => {
                    if (thumbElm.classList.contains(`attr-centered`)) {
                        swiper.slideTo(Math.floor(swiper.slides.length / 2))
                    }
                },
                slideChange: (swiper) => {

                    swiper.el.closest(`.goods__innerSldsSld`).classList.add(`is-changing`)
                    setTimeout(() => {
                        swiper.el.closest(`.goods__innerSldsSld`).classList.remove(`is-changing`)
                    }, 400);

                    // クリックされたスライドのインデックスを取得
                    const clickedIndex = swiper.slides[swiper.activeIndex].getAttribute("data-swiper-slide-index");
                    // console.log(clickedIndex);
                    if (clickedIndex !== undefined) {
                        let index = parseInt(clickedIndex)
                        if (index > swiper.slides.length - 1) {
                            index = index - swiper.slides.length
                        }

                        thumbSwiper.slideToLoop(index);
                    }
                }
            }
        });
    })
}

{
    const modalCharSwiperElm = document.querySelector(`#modal-char .charSwiper`)
    const modalCharSwiperPrevElm = document.querySelector("#modal-char .swiper-button-prev")
    const modalCharSwiperNextElm = document.querySelector("#modal-char .swiper-button-next")

    const modalCharOnInit = (swiper: Swiper) => {
        const charBtns = document.querySelectorAll(`.flavor__innerPcCnt .Flavorinfo__rightChar`)
        const charBtnsSp = document.querySelectorAll(`.flavor__innerTb .Flavorinfo__rightChar`)

        window.sasaken = swiper;

        [charBtns, charBtnsSp].forEach((btns) => {
            btns.forEach((charBtn, charBtnIndex) => {
                charBtn.addEventListener("click", () => {
                    swiper.slideToLoop(charBtnIndex, 1)
                })
            })
        })
    }

    const modalCharOnUpdate = (swiper) => {

        const res = slidesOnUpdate(swiper)

        const prevBtns = modalCharSwiperPrevElm.querySelectorAll(`.btn`)
        const nextBtns = modalCharSwiperNextElm.querySelectorAll(`.btn`);

        [
            [prevBtns, res.previous],
            [nextBtns, res.next],
        ].forEach((val) => {
            val[0].forEach((btn, index) => {
                btn.classList.remove(`is-crnt`)

                if (val[1] === index) {
                    btn.classList.add(`is-crnt`)
                }
            })
        })
    }

    new Swiper(modalCharSwiperElm, {
        modules: [Navigation, EffectFade],
        navigation: {
            nextEl: modalCharSwiperNextElm,
            prevEl: modalCharSwiperPrevElm,
        },
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        fadeEffect: {
            crossFade: true,
        },
        on: {
            init: (swiper) => {
                modalCharOnInit(swiper)
                modalCharOnUpdate(swiper)
            },
            slideChange: modalCharOnUpdate,
        }
    });
}